/* Secondary expiry check for cached pages and restored/long-lived tabs. */
(() => {
 if (window.phqNewsExpiryInstalled) return;
 window.phqNewsExpiryInstalled = true;
 const refresh = () => {
  const now = Date.now()/1000;
  document.querySelectorAll('[data-phq-news-until]').forEach(row => {const until=Number(row.dataset.phqNewsUntil); row.hidden=!Number.isFinite(until)||until<=now;});
  document.querySelectorAll('[data-phq-news-box]').forEach(box => {
   const hasNews=Array.from(box.querySelectorAll('[data-phq-news-until]')).some(row=>!row.hidden);
   box.querySelectorAll('[data-phq-news-fallback]').forEach(guide=>{guide.hidden=hasNews;});
   box.querySelectorAll('[data-phq-news-more]').forEach(link=>{link.hidden=!hasNews;});
   box.querySelectorAll('[data-phq-news-guide-link]').forEach(link=>{link.hidden=hasNews;});
   box.querySelectorAll('[data-phq-news-current-note]').forEach(note=>{note.hidden=!hasNews;});
   box.querySelectorAll('[data-phq-news-guide-note]').forEach(note=>{note.hidden=hasNews;});
   box.hidden=false;
  });
  document.querySelectorAll('[data-phq-news-empty]').forEach(empty => {empty.hidden=Array.from(document.querySelectorAll('[data-phq-news-until]')).some(row=>!row.hidden);});
  document.querySelectorAll('[data-phq-news-overdue]').forEach(notice => {const until=Number(notice.dataset.phqNewsOverdue);notice.hidden=Number.isFinite(until)&&until>now;});
 };
 refresh();window.addEventListener('pageshow',refresh);document.addEventListener('visibilitychange',refresh);document.addEventListener('shopify:section:load',refresh);setInterval(refresh,15000);
})();
